// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'erase';

export const Component = () => (
  <path d='m24.09 7.322-5.89-5.89A1.408 1.408 0 0 0 17.146 1c-.431 0-.766.144-1.054.431L.432 17.092A1.408 1.408 0 0 0 0 18.146c0 .431.144.767.431 1.054l4.359 4.359h16.283c.336 0 .527-.144.527-.48 0-.334-.191-.526-.527-.526H10.92l13.17-13.17c.288-.24.432-.575.432-1.006 0-.43-.144-.766-.431-1.054v-.001ZM9.532 22.552h-4.12c-.047.048-.143.048-.19.048l-4.12-4.119c-.096-.191-.143-.287-.143-.335 0-.048.047-.144.143-.335L9.82 9.142l6.56 6.561-6.848 6.849Zm13.89-13.841-6.323 6.322-6.609-6.61 6.322-6.321c.191-.097.287-.144.335-.144.144 0 .24.047.335.144l5.94 5.89c.095.192.143.335.143.383 0 .048-.048.144-.144.335Z' />
);

export const viewBox = '0 0 25 25';
